<template>
  <div class="appItem">
    <div class="appItem-title flexsb mb-24">
      <p class="font16 fontdark fontbig">{{ item.name }}</p>
      <p class="fonttwodark">APPID:{{ item.id }}</p>
    </div>
    <Tooltip
      :transfer="true"
      max-width="200"
      :content="item.appDescribe"
      placement="top"
      v-if="item.descTip"
    >
      <p
        class="appItem-text"
        @mouseover="mouseOver($event, item, 'desc')"
        @onmouseout="mouseLeave($event, item, 'desc')"
      >
        {{ item.appDescribe }}
      </p>
    </Tooltip>
    <p
      class="appItem-text mt-24"
      @mouseover="mouseOver($event, item, 'desc')"
      @onmouseout="mouseLeave($event, item, 'desc')"
      v-else
    >
      {{ item.appDescribe }}
    </p>
    <div class="appItem-btm flexsb mt-24">
      <p class="fonttwodark btmp">
        <span>{{ item.cName }}</span>
      </p>
      <p class="fonttwodark">创建时间:{{ item.createTime }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    item: Object,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    mouseOver(e, item, type) {
      let target = e.target;
      if (type == "name") {
        //单行超出显示
        if (target.scrollWidth > target.offsetWidth) {
            item.nameTip = true;
        }
      } else {
        //多行超出显示
        if (target.scrollHeight > target.offsetHeight) {
          if (type == "desc") {
            item.descTip = true;
          }
        }
      }
    },
    mouseLeave(e, item) {
      if (type == "desc") {
        if (item.descTip) {
          item.descTip = false;
        }
      } else if (type == "name") {
        if (item.nameTip) {
          item.nameTip = false;
        }
      }
    },
  },
};
</script>
<style lang="scss">
.appItem {
  width: 100%;
  height: 192px;
  background: #fafbfc;
  border-radius: 8px;
  border: 1px solid #f6f7f9;
  padding: 24px 32px 16px 32px;
  font-family: MicrosoftYaHeiSemibold;
  &-text {
    height: 42px;
    font-family: MicrosoftYaHei;
    color: #919caf;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    text-overflow: -o-ellipsis-lastline;
  }
  &-btm {
    > .btmp {
      display: flex;
      align-items: center;
    }
    img {
      border-radius: 50%;
      width: 36px;
      height: 36px;
    }
  }
}
</style>